var map = {
	"./289x193.jpg": 22768,
	"./Social-media/facebook.png": 23883,
	"./Social-media/instagram.png": 40523,
	"./Social-media/linkedin.png": 47889,
	"./Social-media/pinterest.png": 12009,
	"./Social-media/twitter.png": 20578,
	"./Social-media/youtube.png": 41940,
	"./Symptoms/breathing-problem.svg": 65771,
	"./Symptoms/chest-pain.svg": 39121,
	"./Symptoms/child-health.svg": 41776,
	"./Symptoms/cold.svg": 91959,
	"./Symptoms/eye.svg": 29684,
	"./Symptoms/female-health.svg": 14688,
	"./Symptoms/fever.svg": 59701,
	"./Symptoms/headache.svg": 54798,
	"./Symptoms/insomnia.svg": 24233,
	"./Symptoms/joint-pain.svg": 10432,
	"./Symptoms/mental-health.svg": 33093,
	"./Symptoms/nausea.svg": 75172,
	"./Symptoms/sorethroat.svg": 1702,
	"./Symptoms/tooth.svg": 77981,
	"./about-img1.jpg": 63766,
	"./about-img2.jpg": 55905,
	"./about-img3.jpg": 65956,
	"./aboutus-fift-1.jpg": 13243,
	"./app-bg.png": 5399,
	"./app-img.svg": 63321,
	"./app-store-1.png": 44329,
	"./app-store.png": 4031,
	"./appointment-front-icon1.png": 50100,
	"./appointment-front-icon2.png": 69007,
	"./appointment-front-icon3.png": 29990,
	"./appointment-ryt-1.png": 74829,
	"./ban-fift-icon1.png": 69878,
	"./ban-fift-icon2.png": 51501,
	"./ban-fift-icon3.png": 11556,
	"./ban-fift-icon4.png": 93211,
	"./ban-fift-icon5.png": 78994,
	"./ban-fift-icon6.png": 69705,
	"./ban-fift-icon7.png": 14880,
	"./ban-fift-icon8.png": 59111,
	"./ban-right-img1.jpg": 30489,
	"./ban-right-img2.jpg": 74350,
	"./ban-sixteen-img1.png": 83375,
	"./ban-sixteen-img2.png": 48116,
	"./banner-1.png": 68300,
	"./banner-11.png": 25663,
	"./banner-2.jpg": 16887,
	"./banner-3.jpg": 45722,
	"./banner-bg-icon1.png": 75711,
	"./banner-bg-icon2.png": 62148,
	"./banner-bg-icon3.png": 88301,
	"./banner-bg.png": 59368,
	"./banner-cart.png": 93727,
	"./banner-doc.png": 57827,
	"./banner-fifteen-ryt.png": 82576,
	"./banner-fifteen-vd.jpg": 65567,
	"./banner-fifteen.png": 90726,
	"./banner-four.png": 52785,
	"./banner-health.png": 66255,
	"./banner-img.png": 25676,
	"./banner-img1.png": 1087,
	"./banner-img2.png": 64228,
	"./banner-img3.png": 18125,
	"./banner-six-2.png": 65216,
	"./banner-sixteen-bg.png": 59269,
	"./bg/Map-thirteen.png": 18104,
	"./bg/app-bg.jpg": 39997,
	"./bg/app-bg.png": 39117,
	"./bg/appoint-bg.png": 34967,
	"./bg/atom-bond.png": 36703,
	"./bg/baby-star.png": 1153,
	"./bg/ban-bg-01.png": 56031,
	"./bg/ban-bg-02.png": 19172,
	"./bg/banner-11-bg.png": 84133,
	"./bg/banner-bg.png": 30954,
	"./bg/big-paw.png": 87289,
	"./bg/blue-rainbow.png": 30003,
	"./bg/blue-star.png": 45217,
	"./bg/care-bg-01.png": 67265,
	"./bg/care-bg-02.png": 18282,
	"./bg/care-bg.png": 93745,
	"./bg/center-bg.png": 15877,
	"./bg/clients-says.jpg": 2387,
	"./bg/clinic-bg-01.png": 86318,
	"./bg/cloud-1.png": 27965,
	"./bg/cloud-2.png": 44198,
	"./bg/core-bg.png": 23331,
	"./bg/counter-bg-01-.png": 32267,
	"./bg/counter-bg-01.png": 79108,
	"./bg/counter-bg-02.png": 15967,
	"./bg/counter-bg.png": 54034,
	"./bg/dental-bg.png": 58336,
	"./bg/dental-shape.png": 18930,
	"./bg/doc-shape-01.png": 83604,
	"./bg/doc-shape-02.png": 5071,
	"./bg/doctor-bg.jpg": 5603,
	"./bg/doctor-bg.png": 77163,
	"./bg/doctor-shape-img1.png": 22604,
	"./bg/doctor-shape-img2.png": 73287,
	"./bg/dot-1.png": 20443,
	"./bg/dot-2.png": 65408,
	"./bg/ecg-wave.png": 4341,
	"./bg/ecg.png": 21039,
	"./bg/footer-map.jpg": 58738,
	"./bg/gold-star.png": 96687,
	"./bg/hand.png": 31869,
	"./bg/header-after.png": 44480,
	"./bg/header-bg.png": 66785,
	"./bg/health-care.png": 9696,
	"./bg/heart-1.png": 74414,
	"./bg/heart-banner-bg.png": 53169,
	"./bg/heart-bg.png": 63406,
	"./bg/heart-in-hand.png": 14950,
	"./bg/heart-plus.png": 45895,
	"./bg/hexagen-group-1.png": 21602,
	"./bg/hexagen-group-3.png": 81936,
	"./bg/hexagen-group-4.png": 67311,
	"./bg/hexagen-group-5.png": 85766,
	"./bg/hexagon-group-2.png": 12519,
	"./bg/home-10-banner-img.png": 62320,
	"./bg/home-10-banner.png": 8994,
	"./bg/home-12-banner-1.png": 83398,
	"./bg/home-12-banner-2.png": 24637,
	"./bg/home-12-banner-bg-1.png": 90316,
	"./bg/home-12-banner-bg-2.png": 58791,
	"./bg/home-12-pricing-bg-1.png": 37258,
	"./bg/home-12-pricing-bg-2.png": 86241,
	"./bg/home-12-pricing-bg-3.png": 1624,
	"./bg/home-12-pricing-bg-4.png": 93143,
	"./bg/home-12-pricing-bg-5.png": 50126,
	"./bg/home-12-testimonial.png": 99813,
	"./bg/home-12-why-us.png": 41437,
	"./bg/home-13-banner-img.png": 94113,
	"./bg/home-13-banner.png": 90811,
	"./bg/logo.svg": 87691,
	"./bg/map.png": 6098,
	"./bg/online-bg.png": 65103,
	"./bg/pink-star.png": 62053,
	"./bg/plan-bg-01.png": 85051,
	"./bg/plan-bg-02.png": 6720,
	"./bg/pluse-1.png": 56371,
	"./bg/pluse-2.png": 81880,
	"./bg/pluse-3.png": 54593,
	"./bg/pluse-4.png": 87854,
	"./bg/pluse-white.png": 36917,
	"./bg/pricing-bg.png": 51272,
	"./bg/pulse-6.png": 95582,
	"./bg/pulse-7.png": 13895,
	"./bg/rainbow-2.png": 54119,
	"./bg/ring-1.png": 25218,
	"./bg/ring-2.png": 73401,
	"./bg/safe-bg-01.png": 21309,
	"./bg/safe-bg-02.png": 40102,
	"./bg/serv-img-01.png": 83486,
	"./bg/serv-img-02.png": 69237,
	"./bg/service-bg-01.png": 87253,
	"./bg/service-bg-02.png": 1502,
	"./bg/service-bg.png": 92053,
	"./bg/small-paw.png": 76414,
	"./bg/star-1.png": 78044,
	"./bg/store-bg-01.png": 72827,
	"./bg/store-bg.png": 44047,
	"./bg/testi-bg.png": 51409,
	"./bg/title-bg.png": 1668,
	"./bg/two-paw.png": 67081,
	"./bg/update-bg-01.png": 98457,
	"./bg/update-bg.png": 8233,
	"./bg/wave.svg": 77125,
	"./blog-1.jpg": 88714,
	"./blog-2.jpg": 80789,
	"./blog-3.jpg": 60120,
	"./blog-4.jpg": 23211,
	"./blog/blog-01.jpg": 63373,
	"./blog/blog-02.jpg": 94146,
	"./blog/blog-03.jpg": 85855,
	"./blog/blog-04.jpg": 7572,
	"./blog/blog-05.jpg": 79377,
	"./blog/blog-06.jpg": 63526,
	"./blog/blog-07.jpg": 53635,
	"./blog/blog-08.jpg": 96024,
	"./blog/blog-09.jpg": 341,
	"./blog/blog-10.jpg": 82255,
	"./blog/blog-11.jpg": 9874,
	"./blog/blog-12.jpg": 19773,
	"./blog/blog-13.jpg": 68640,
	"./blog/blog-14.jpg": 51475,
	"./blog/blog-15.jpg": 65014,
	"./blog/blog-16.jpg": 35361,
	"./blog/blog-17.jpg": 57316,
	"./blog/blog-thumb-01.jpg": 47616,
	"./blog/blog-thumb-02.jpg": 61231,
	"./blog/blog-thumb-03.jpg": 88850,
	"./blog/blog-thumb-04.jpg": 14337,
	"./blog/blog-thumb-05.jpg": 36292,
	"./blog/blog-thumb-06.jpg": 30451,
	"./blog/blog-thumb-07.jpg": 43990,
	"./blog/blog-thumb-08.jpg": 69477,
	"./blog/blog-thumb-09.jpg": 25960,
	"./blog/blog-thumb-10.jpg": 26150,
	"./blog/blog-wrap-01.jpg": 93686,
	"./blog/blog-wrap-02.jpg": 85825,
	"./blog/blog-wrap-03.jpg": 95876,
	"./blog/blog-wrap-04.jpg": 38607,
	"./blog/eye-blog-01.jpg": 45853,
	"./blog/eye-blog-02.jpg": 91698,
	"./blog/eye-blog-03.jpg": 68079,
	"./blog/eye-blog-04.jpg": 41700,
	"./blog/veterinary-blog-01.jpg": 97755,
	"./blog/veterinary-blog-02.jpg": 71308,
	"./blog/veterinary-blog-03.jpg": 69097,
	"./book-appointment-bg.png": 78151,
	"./category/1.png": 75312,
	"./category/2.png": 40715,
	"./category/3.png": 93410,
	"./category/4.png": 86205,
	"./category/5.png": 65076,
	"./category/doc-sel-01.jpg": 79138,
	"./check.png": 75286,
	"./choose-us-six.png": 79129,
	"./chooseus-ryt-1.png": 6051,
	"./chooseus-ryt-2.png": 20776,
	"./clients/client-01.jpg": 97620,
	"./clients/client-02.jpg": 27331,
	"./clients/client-03.jpg": 84198,
	"./clients/client-04.jpg": 3277,
	"./clients/client-05.jpg": 51056,
	"./clients/client-06.jpg": 65407,
	"./clients/client-07.jpg": 57346,
	"./clients/client-08.jpg": 11737,
	"./clients/client-09.jpg": 90684,
	"./clients/client-10.jpg": 42586,
	"./clients/re-image-1.jpg": 28434,
	"./clients/re-image-2.jpg": 82589,
	"./clients/re-image-3.jpg": 14496,
	"./clients/re-image-4.jpg": 4659,
	"./clients/re-image-5.jpg": 59894,
	"./clients/re-image-6.jpg": 52033,
	"./clients/re-image-7.jpg": 62084,
	"./clients/re-image-8.jpg": 73591,
	"./clients/re-image-9.jpg": 5306,
	"./clinic/clinic-01.png": 9657,
	"./clinic/clinic-02.png": 43074,
	"./clinic/clinic-03.png": 17227,
	"./clinic/clinic-04.png": 67316,
	"./clinic/clinic-05.png": 88445,
	"./clinic/clinic-1.jpg": 87051,
	"./clinic/clinic-10.jpg": 67187,
	"./clinic/clinic-11.jpg": 4022,
	"./clinic/clinic-2.jpg": 2396,
	"./clinic/clinic-3.jpg": 89273,
	"./clinic/clinic-4.jpg": 52554,
	"./clinic/clinic-5.jpg": 20295,
	"./clinic/clinic-6.jpg": 40312,
	"./clinic/clinic-7.jpg": 44629,
	"./clinic/clinic-8.jpg": 7814,
	"./clinic/clinic-9.jpg": 97923,
	"./clinic/default-clinic.png": 80781,
	"./clinic/service-1.jpg": 63110,
	"./clinic/service-2.jpg": 4529,
	"./clinic/service-3.jpg": 26004,
	"./clinic/service-4.jpg": 27967,
	"./clinic/service-5.jpg": 7970,
	"./clinic/spec-01.jpg": 61858,
	"./clinic/spec-02.jpg": 31085,
	"./clinic/spec-03.jpg": 86192,
	"./cloud-bg.png": 77973,
	"./coming-soon.png": 62501,
	"./contact-fourteen.png": 39013,
	"./contact-icon2.png": 38958,
	"./contact-icon3.png": 28951,
	"./doc-slide-1.png": 37330,
	"./doctor-banner.png": 77070,
	"./doctor-banner1.png": 83605,
	"./doctors/book-doc-01.jpg": 71861,
	"./doctors/book-doc-02.jpg": 45610,
	"./doctors/book-doc-03.jpg": 1447,
	"./doctors/book-doc-04.jpg": 95452,
	"./doctors/book-doc-05.jpg": 16505,
	"./doctors/doctor-01.jpg": 64084,
	"./doctors/doctor-02.jpg": 58563,
	"./doctors/doctor-03.jpg": 20038,
	"./doctors/doctor-04.jpg": 1485,
	"./doctors/doctor-05.jpg": 16912,
	"./doctors/doctor-06.jpg": 1247,
	"./doctors/doctor-07.jpg": 88578,
	"./doctors/doctor-08.jpg": 1497,
	"./doctors/doctor-09.jpg": 57148,
	"./doctors/doctor-10.jpg": 17274,
	"./doctors/doctor-11.jpg": 11735,
	"./doctors/doctor-12.jpg": 77512,
	"./doctors/doctor-13.jpg": 39877,
	"./doctors/doctor-14.jpg": 29054,
	"./doctors/doctor-15.jpg": 187,
	"./doctors/doctor-16.jpg": 57388,
	"./doctors/doctor-17.jpg": 2761,
	"./doctors/doctor-18.jpg": 40402,
	"./doctors/doctor-19.jpg": 8335,
	"./doctors/doctor-20.jpg": 65023,
	"./doctors/doctor-21.jpg": 56962,
	"./doctors/doctor-22.jpg": 42541,
	"./doctors/doctor-23.jpg": 81296,
	"./doctors/doctor-24.jpg": 16451,
	"./doctors/doctor-25.png": 47650,
	"./doctors/doctor-26.png": 3737,
	"./doctors/doctor-27.png": 97488,
	"./doctors/doctor-thumb-01.jpg": 8593,
	"./doctors/doctor-thumb-02.jpg": 50822,
	"./doctors/doctor-thumb-03.jpg": 31875,
	"./doctors/doctor-thumb-04.jpg": 720,
	"./doctors/doctor-thumb-05.jpg": 44173,
	"./doctors/doctor-thumb-06.jpg": 95682,
	"./doctors/doctor-thumb-07.jpg": 32031,
	"./doctors/doctor-thumb-08.jpg": 87932,
	"./doctors/doctor-thumb-09.jpg": 1657,
	"./doctors/doctor-thumb-10.jpg": 21811,
	"./doctors/doctor-thumb-11.jpg": 66550,
	"./doctors/doctor-thumb-12.jpg": 16161,
	"./doctors/eye-doctor-01.jpg": 4396,
	"./doctors/eye-doctor-02.jpg": 47195,
	"./doctors/eye-doctor-03.jpg": 15710,
	"./doctors/eye-doctor-04.jpg": 44357,
	"./doctors/eye-doctor-05.jpg": 17192,
	"./doctors/matjohn.png": 75718,
	"./doctors/veterinary-doctor-01.jpg": 13098,
	"./doctors/veterinary-doctor-02.jpg": 37237,
	"./doctors/veterinary-doctor-03.jpg": 92408,
	"./doctors/veterinary-doctor-04.jpg": 96011,
	"./down-arrow-img.png": 35162,
	"./dr-slider.png": 51494,
	"./error-404.png": 14679,
	"./error-500.png": 52818,
	"./excel.svg": 84143,
	"./experts-1.jpg": 10475,
	"./experts-2.jpg": 42780,
	"./experts-3.jpg": 40153,
	"./eye.png": 93893,
	"./faq-img-2.jpg": 13,
	"./faq-img.png": 34072,
	"./faq/faq-01.jpg": 3331,
	"./favicon-old.png": 20850,
	"./favicon.png": 90286,
	"./feature-service-1.jpg": 40292,
	"./feature-service-2.jpg": 40339,
	"./feature-service-3.jpg": 85078,
	"./featured-bg.jpg": 70816,
	"./features/facility-01.jpg": 54706,
	"./features/facility-02.jpg": 9722,
	"./features/facility-03.jpg": 73559,
	"./features/facility-04.jpg": 92364,
	"./features/facility-05.jpg": 30409,
	"./features/facility-06.jpg": 87326,
	"./features/facility-07.jpg": 35163,
	"./features/feature-01.jpg": 43976,
	"./features/feature-02.jpg": 54903,
	"./features/feature-03.jpg": 83738,
	"./features/feature-04.jpg": 20201,
	"./features/feature-05.jpg": 64940,
	"./features/feature-06.jpg": 25563,
	"./features/feature-07.jpg": 40606,
	"./features/feature-08.jpg": 68349,
	"./features/feature-09.jpg": 42784,
	"./features/feature-10.jpg": 90446,
	"./features/feature-11.jpg": 16907,
	"./features/feature-12.jpg": 49212,
	"./features/feature-13.jpg": 46585,
	"./features/feature-14.jpg": 33994,
	"./features/feature-15.jpg": 56647,
	"./features/feature-16.jpg": 94072,
	"./features/feature.png": 12122,
	"./feedback-bg.png": 64249,
	"./feedback-fifteen.png": 25597,
	"./feedback-inner.png": 43886,
	"./feedback-six.png": 33386,
	"./feedback-sixteen.png": 95754,
	"./fifteen-bg-icon-1.png": 42033,
	"./fifteen-bg-icon-2.png": 11866,
	"./fifteen-bg-icon-3.png": 13091,
	"./flags/ad.png": 94663,
	"./flags/ae.png": 76350,
	"./flags/af.png": 43701,
	"./flags/ag.png": 74604,
	"./flags/ai.png": 14546,
	"./flags/al.png": 1759,
	"./flags/am.png": 5430,
	"./flags/ao.png": 47108,
	"./flags/ar.png": 91553,
	"./flags/as.png": 6936,
	"./flags/at.png": 98455,
	"./flags/au.png": 39086,
	"./flags/aw.png": 97820,
	"./flags/ax.png": 1419,
	"./flags/az.png": 28473,
	"./flags/ba.png": 17819,
	"./flags/bb.png": 20256,
	"./flags/bd.png": 94486,
	"./flags/be.png": 48287,
	"./flags/bf.png": 63012,
	"./flags/bg.png": 26253,
	"./flags/bh.png": 57018,
	"./flags/bi.png": 63203,
	"./flags/bj.png": 84872,
	"./flags/bl.png": 88702,
	"./flags/bm.png": 64487,
	"./flags/bn.png": 13804,
	"./flags/bo.png": 25429,
	"./flags/bq.png": 43499,
	"./flags/br.png": 78096,
	"./flags/bs.png": 10201,
	"./flags/bt.png": 5222,
	"./flags/bv.png": 67860,
	"./flags/bw.png": 88989,
	"./flags/by.png": 63155,
	"./flags/bz.png": 88664,
	"./flags/ca.png": 20276,
	"./flags/cc.png": 57638,
	"./flags/cd.png": 62617,
	"./flags/cf.png": 12267,
	"./flags/cg.png": 48610,
	"./flags/ch.png": 49477,
	"./flags/ci.png": 15612,
	"./flags/ck.png": 30702,
	"./flags/cl.png": 13793,
	"./flags/cm.png": 41080,
	"./flags/cn.png": 15571,
	"./flags/co.png": 64810,
	"./flags/cr.png": 703,
	"./flags/cu.png": 72672,
	"./flags/cv.png": 70235,
	"./flags/cw.png": 48690,
	"./flags/cx.png": 77845,
	"./flags/cy.png": 66220,
	"./flags/cz.png": 16903,
	"./flags/de.png": 5593,
	"./flags/dj.png": 32558,
	"./flags/dk.png": 32055,
	"./flags/dm.png": 31041,
	"./flags/do.png": 5523,
	"./flags/dz.png": 58366,
	"./flags/ec.png": 72676,
	"./flags/ee.png": 5938,
	"./flags/eg.png": 29920,
	"./flags/er.png": 98653,
	"./flags/es.png": 77524,
	"./flags/et.png": 53163,
	"./flags/fi.png": 26831,
	"./flags/fj.png": 7924,
	"./flags/fk.png": 29053,
	"./flags/flag-01.png": 68972,
	"./flags/flag-02.png": 89031,
	"./flags/flag-03.png": 87070,
	"./flags/flag-04.png": 28081,
	"./flags/flag-05.png": 13864,
	"./flags/fm.png": 53835,
	"./flags/fo.png": 80889,
	"./flags/fr.png": 27020,
	"./flags/ga.png": 73696,
	"./flags/gb.png": 35675,
	"./flags/gd.png": 25709,
	"./flags/ge.png": 71812,
	"./flags/gf.png": 8671,
	"./flags/gg.png": 11734,
	"./flags/gh.png": 89041,
	"./flags/gi.png": 78824,
	"./flags/gl.png": 91701,
	"./flags/gm.png": 55788,
	"./flags/gn.png": 58439,
	"./flags/gp.png": 53177,
	"./flags/gq.png": 46928,
	"./flags/gr.png": 77099,
	"./flags/gs.png": 86594,
	"./flags/gt.png": 48317,
	"./flags/gu.png": 10836,
	"./flags/gw.png": 50758,
	"./flags/gy.png": 57496,
	"./flags/hk.png": 5907,
	"./flags/hn.png": 21038,
	"./flags/hr.png": 39026,
	"./flags/ht.png": 5764,
	"./flags/hu.png": 69005,
	"./flags/id.png": 45535,
	"./flags/ie.png": 67446,
	"./flags/il.png": 30503,
	"./flags/im.png": 42814,
	"./flags/in.png": 28565,
	"./flags/io.png": 62028,
	"./flags/iq.png": 99778,
	"./flags/ir.png": 55865,
	"./flags/is.png": 49616,
	"./flags/it.png": 61839,
	"./flags/je.png": 12727,
	"./flags/jm.png": 65391,
	"./flags/jo.png": 81405,
	"./flags/jp.png": 1018,
	"./flags/ke.png": 75208,
	"./flags/kg.png": 47354,
	"./flags/kh.png": 16589,
	"./flags/ki.png": 53348,
	"./flags/km.png": 10592,
	"./flags/kn.png": 8155,
	"./flags/kp.png": 87397,
	"./flags/kr.png": 58615,
	"./flags/kw.png": 2730,
	"./flags/ky.png": 58196,
	"./flags/kz.png": 80655,
	"./flags/la.png": 82037,
	"./flags/lb.png": 96286,
	"./flags/lc.png": 48775,
	"./flags/li.png": 16045,
	"./flags/lk.png": 99007,
	"./flags/lr.png": 70478,
	"./flags/ls.png": 53623,
	"./flags/lt.png": 47832,
	"./flags/lu.png": 68961,
	"./flags/lv.png": 11530,
	"./flags/ly.png": 38653,
	"./flags/ma.png": 22894,
	"./flags/mc.png": 98460,
	"./flags/md.png": 95859,
	"./flags/me.png": 63946,
	"./flags/mg.png": 248,
	"./flags/mh.png": 75055,
	"./flags/mk.png": 69940,
	"./flags/ml.png": 19851,
	"./flags/mm.png": 29346,
	"./flags/mn.png": 95929,
	"./flags/mo.png": 6032,
	"./flags/mp.png": 1191,
	"./flags/mq.png": 48702,
	"./flags/mr.png": 50805,
	"./flags/ms.png": 98540,
	"./flags/mt.png": 74787,
	"./flags/mu.png": 10682,
	"./flags/mv.png": 31793,
	"./flags/mw.png": 21576,
	"./flags/mx.png": 51423,
	"./flags/my.png": 54486,
	"./flags/mz.png": 68461,
	"./flags/na.png": 14255,
	"./flags/nc.png": 56445,
	"./flags/ne.png": 89675,
	"./flags/nf.png": 2032,
	"./flags/ng.png": 8281,
	"./flags/ni.png": 21943,
	"./flags/nl.png": 79850,
	"./flags/no.png": 10433,
	"./flags/np.png": 19862,
	"./flags/nr.png": 84388,
	"./flags/nu.png": 94331,
	"./flags/nz.png": 14444,
	"./flags/om.png": 98260,
	"./flags/pa.png": 55953,
	"./flags/pe.png": 58613,
	"./flags/pf.png": 72862,
	"./flags/pg.png": 25351,
	"./flags/ph.png": 40608,
	"./flags/pk.png": 2587,
	"./flags/pl.png": 38724,
	"./flags/pm.png": 92621,
	"./flags/pn.png": 78646,
	"./flags/pr.png": 88106,
	"./flags/ps.png": 20019,
	"./flags/pt.png": 22620,
	"./flags/pw.png": 30199,
	"./flags/py.png": 20089,
	"./flags/qa.png": 40522,
	"./flags/re.png": 90831,
	"./flags/ro.png": 23301,
	"./flags/rs.png": 87049,
	"./flags/ru.png": 74527,
	"./flags/rw.png": 3469,
	"./flags/sa.png": 66436,
	"./flags/sb.png": 21087,
	"./flags/sc.png": 24758,
	"./flags/sd.png": 24585,
	"./flags/se.png": 69760,
	"./flags/sg.png": 33874,
	"./flags/sh.png": 63029,
	"./flags/si.png": 93932,
	"./flags/sk.png": 95678,
	"./flags/sl.png": 36689,
	"./flags/sm.png": 38824,
	"./flags/sn.png": 24099,
	"./flags/so.png": 6522,
	"./flags/sr.png": 93743,
	"./flags/ss.png": 54726,
	"./flags/st.png": 47801,
	"./flags/sv.png": 20747,
	"./flags/sx.png": 46565,
	"./flags/sy.png": 17148,
	"./flags/sz.png": 17783,
	"./flags/tc.png": 31775,
	"./flags/td.png": 73120,
	"./flags/tf.png": 79154,
	"./flags/tg.png": 28155,
	"./flags/th.png": 48268,
	"./flags/tj.png": 6673,
	"./flags/tk.png": 16743,
	"./flags/tl.png": 25224,
	"./flags/tm.png": 65169,
	"./flags/tn.png": 56858,
	"./flags/to.png": 78435,
	"./flags/tr.png": 9062,
	"./flags/tt.png": 35856,
	"./flags/tv.png": 86018,
	"./flags/tw.png": 7147,
	"./flags/tz.png": 26542,
	"./flags/ua.png": 61478,
	"./flags/ug.png": 88272,
	"./flags/um.png": 66090,
	"./flags/us-one.png": 97791,
	"./flags/us.png": 70628,
	"./flags/us1.png": 50631,
	"./flags/uy.png": 81470,
	"./flags/uz.png": 67221,
	"./flags/va.png": 41063,
	"./flags/vc.png": 2005,
	"./flags/ve.png": 23427,
	"./flags/vg.png": 9841,
	"./flags/vi.png": 24863,
	"./flags/vn.png": 96832,
	"./flags/vu.png": 39731,
	"./flags/wf.png": 19311,
	"./flags/ws.png": 25266,
	"./flags/ye.png": 97478,
	"./flags/yt.png": 63839,
	"./flags/za.png": 59107,
	"./flags/zm.png": 12447,
	"./flags/zw.png": 61221,
	"./footer-arrow.png": 21617,
	"./footer-fift-bg.png": 92705,
	"./footer-fift-payment.png": 10768,
	"./footer-logo.png": 60317,
	"./footer-logo.svg": 64525,
	"./gmaps.png": 32888,
	"./google-img.svg": 35473,
	"./google-map.png": 93764,
	"./google-play.png": 93438,
	"./google-store-1.png": 14479,
	"./home-01.jpg": 97297,
	"./home-02.jpg": 39526,
	"./home-03.jpg": 78051,
	"./home-04.jpg": 20048,
	"./home-05.jpg": 20973,
	"./home-06.jpg": 8066,
	"./home-07.jpg": 4383,
	"./home-08.jpg": 76636,
	"./home-09.jpg": 20985,
	"./home-10.jpg": 34195,
	"./home-11.jpg": 89430,
	"./hospital.png": 13898,
	"./icon-01.png": 89623,
	"./icon-02.png": 892,
	"./icon-03.png": 18405,
	"./icon-04.png": 33738,
	"./icon-05.png": 84499,
	"./icons/Group.png": 45940,
	"./icons/aboutus-icon1.svg": 23057,
	"./icons/add-circle.png": 16459,
	"./icons/angry.svg": 29950,
	"./icons/anguish.svg": 15314,
	"./icons/atom-bond2.svg": 70276,
	"./icons/ban-img-icon-4.svg": 29049,
	"./icons/ban-img-icon5.svg": 17183,
	"./icons/ban-img-icon6.svg": 38156,
	"./icons/ban-six-icon1.svg": 33998,
	"./icons/ban-six-icon2.svg": 28365,
	"./icons/ban-six-icon3.svg": 92908,
	"./icons/bath-tub.svg": 18650,
	"./icons/bottel.svg": 95737,
	"./icons/browse-01.jpg": 21863,
	"./icons/browse-02.jpg": 5368,
	"./icons/browse-03.jpg": 50197,
	"./icons/browse-04.jpg": 13134,
	"./icons/browse-05.jpg": 8971,
	"./icons/camera.svg": 80662,
	"./icons/cardiology.png": 92356,
	"./icons/ch.svg": 62870,
	"./icons/check.svg": 87121,
	"./icons/choose-01.svg": 99056,
	"./icons/choose-02.svg": 39747,
	"./icons/choose-03.svg": 25106,
	"./icons/choose-04.svg": 59037,
	"./icons/choose-icon1.svg": 31659,
	"./icons/choose-icon2.svg": 92824,
	"./icons/choose-icon3.svg": 27689,
	"./icons/choose-icon4.svg": 25094,
	"./icons/clinic-01.png": 41493,
	"./icons/clinic-02.png": 55742,
	"./icons/clinic-03.png": 27079,
	"./icons/clinic-04.png": 51912,
	"./icons/clinic-05.png": 91857,
	"./icons/clinic-06.png": 67194,
	"./icons/clinic-07.png": 88771,
	"./icons/clinic-08.png": 44900,
	"./icons/clinic-09.png": 71053,
	"./icons/clinic-10.png": 28119,
	"./icons/clinic-11.png": 85102,
	"./icons/clinic-12.png": 56901,
	"./icons/clinic-13.png": 27484,
	"./icons/clinic-hover-01.png": 97898,
	"./icons/clinic-hover-02.png": 46881,
	"./icons/clinic-hover-03.png": 78616,
	"./icons/clinic-hover-04.png": 53783,
	"./icons/clinic-hover-05.png": 10766,
	"./icons/clinic-hover-06.png": 82565,
	"./icons/clinic-hover-07.png": 53148,
	"./icons/clinic-hover-08.png": 56747,
	"./icons/clinic-hover-09.png": 35618,
	"./icons/clinic-hover-10.png": 77576,
	"./icons/contact-icon1.svg": 79114,
	"./icons/count-01.svg": 56292,
	"./icons/count-02.svg": 27095,
	"./icons/count-03.svg": 21766,
	"./icons/count-04.svg": 91177,
	"./icons/customer-service-1.svg": 23707,
	"./icons/customer-service-2.svg": 42344,
	"./icons/device-message.svg": 37807,
	"./icons/discover-1.svg": 3820,
	"./icons/discover-2.svg": 82847,
	"./icons/discover-3.svg": 68206,
	"./icons/discover-4.svg": 79761,
	"./icons/discover-5.svg": 65376,
	"./icons/doc-01.svg": 15581,
	"./icons/doc-02.svg": 77758,
	"./icons/doc-03.svg": 40335,
	"./icons/doct-01.png": 49919,
	"./icons/doct-02.png": 64644,
	"./icons/doctor-icon.svg": 54708,
	"./icons/down-arrow-gray-dark.svg": 91006,
	"./icons/down-arrow-gray.svg": 49397,
	"./icons/drugs-svg.svg": 76857,
	"./icons/edit.svg": 96415,
	"./icons/email-icon.svg": 82165,
	"./icons/email.svg": 52641,
	"./icons/experience-1.svg": 77889,
	"./icons/experience-2.svg": 84754,
	"./icons/experience-3.svg": 99395,
	"./icons/experience-4.svg": 29212,
	"./icons/experience-5.svg": 18685,
	"./icons/experience-6.svg": 64510,
	"./icons/eye-bg.png": 40204,
	"./icons/eye-icon-01.svg": 78208,
	"./icons/eye-icon.svg": 96468,
	"./icons/eye-white-icon.svg": 24208,
	"./icons/facts-1.svg": 5526,
	"./icons/facts-2.svg": 46773,
	"./icons/facts-3.svg": 4788,
	"./icons/facts-4.svg": 54203,
	"./icons/facts-5.svg": 20010,
	"./icons/female.png": 20305,
	"./icons/fifteen-play.svg": 14301,
	"./icons/file.png": 12687,
	"./icons/fluent-password.svg": 65217,
	"./icons/globe.svg": 37410,
	"./icons/google-icon.svg": 68648,
	"./icons/header-icon.svg": 31430,
	"./icons/health-care-1.svg": 25227,
	"./icons/health-care-love.svg": 36446,
	"./icons/healthcare.svg": 20510,
	"./icons/heart-2.svg": 88932,
	"./icons/heart-pulse-fill.svg": 2585,
	"./icons/hex-shape.png": 52006,
	"./icons/hreat-pulse.svg": 88325,
	"./icons/injection.svg": 45306,
	"./icons/lock.svg": 11674,
	"./icons/male.png": 6582,
	"./icons/mic-black.svg": 6102,
	"./icons/mobile-icon.svg": 58709,
	"./icons/mobile.svg": 1857,
	"./icons/password-duotone.svg": 1075,
	"./icons/patient-icon.svg": 75272,
	"./icons/payment-card.png": 82248,
	"./icons/pet-doctor.svg": 5190,
	"./icons/phone-icon.svg": 93261,
	"./icons/phone.png": 79085,
	"./icons/price-icon1.svg": 4181,
	"./icons/price-icon2.svg": 32310,
	"./icons/price-icon3.svg": 96135,
	"./icons/rainbow-1.png": 37713,
	"./icons/rainbow-3.svg": 46571,
	"./icons/rainbow-4.svg": 78980,
	"./icons/search-icon.svg": 4923,
	"./icons/serv-img-icon-1.svg": 68019,
	"./icons/serv-img-icon-2.svg": 97120,
	"./icons/serv-img-icon-3.svg": 59921,
	"./icons/set-cat-01.png": 11888,
	"./icons/set-cat-02.png": 77291,
	"./icons/set-cat-03.png": 13634,
	"./icons/signup-unlock.svg": 92988,
	"./icons/signup-users.svg": 7952,
	"./icons/smart-phone.svg": 5657,
	"./icons/smile.svg": 16521,
	"./icons/smiling-icon.svg": 88174,
	"./icons/star.svg": 44543,
	"./icons/success-tick.svg": 47246,
	"./icons/syringe-svg.svg": 73251,
	"./icons/test-line.svg": 86570,
	"./icons/tick-icon.svg": 1418,
	"./icons/today-icon.svg": 34944,
	"./icons/up-cam.png": 35628,
	"./icons/up-img-1.svg": 96596,
	"./icons/user-doctor.svg": 7842,
	"./icons/video-icon.svg": 23810,
	"./icons/visit-01.png": 69694,
	"./icons/visit-02.png": 71797,
	"./icons/visit-03.png": 19532,
	"./icons/we-are-icon1.svg": 99041,
	"./icons/we-are-icon2.svg": 5906,
	"./icons/we-are-icon3.svg": 20547,
	"./icons/work-01.svg": 75736,
	"./icons/work-02.svg": 33803,
	"./icons/work-03.svg": 56282,
	"./icons/work-04.svg": 63461,
	"./icons/x-icon-01.png": 7771,
	"./icons/x-icon.svg": 65517,
	"./img-01.jpg": 26171,
	"./img-02.jpg": 49196,
	"./img-03.jpg": 20809,
	"./img-04.jpg": 84346,
	"./img-pharmacy1.jpg": 94836,
	"./invoice.png": 10435,
	"./lab-image.jpg": 15395,
	"./location.png": 14238,
	"./login-banner-01.png": 97800,
	"./login-banner.png": 14038,
	"./login-btn.png": 1278,
	"./logo-03.png": 72895,
	"./logo-15.png": 5314,
	"./logo-large.png": 10111,
	"./logo-old.png": 35625,
	"./logo-white.svg": 64415,
	"./logo.png": 65549,
	"./logo.svg": 67503,
	"./mail-box.png": 56153,
	"./maintenance.png": 72123,
	"./map-bg.png": 23382,
	"./marker.png": 80342,
	"./medical-img1.jpg": 16036,
	"./medical-img2.jpg": 93843,
	"./medical-img3.jpg": 7382,
	"./mobile-img.png": 41628,
	"./offer-01.png": 2394,
	"./offer-02.png": 10705,
	"./onboard-img/onb-logo.png": 97095,
	"./onboard-img/onb-slide-img.png": 66005,
	"./partners/partners-1.svg": 6514,
	"./partners/partners-2.svg": 61702,
	"./partners/partners-3.svg": 59735,
	"./partners/partners-4.svg": 86904,
	"./partners/partners-5.svg": 74793,
	"./partners/partners-6.svg": 6682,
	"./patients-img-fifteen.png": 96664,
	"./patients/articles-1.jpg": 796,
	"./patients/articles-2.jpg": 25963,
	"./patients/articles-3.jpg": 30126,
	"./patients/articles-4.jpg": 83541,
	"./patients/patient.jpg": 51524,
	"./patients/patient.png": 2208,
	"./patients/patient1.jpg": 22499,
	"./patients/patient10.jpg": 93243,
	"./patients/patient11.jpg": 73086,
	"./patients/patient12.jpg": 64585,
	"./patients/patient13.jpg": 66796,
	"./patients/patient14.jpg": 27031,
	"./patients/patient15.jpg": 58746,
	"./patients/patient16.jpg": 32325,
	"./patients/patient17.jpg": 88360,
	"./patients/patient18.jpg": 58099,
	"./patients/patient19.jpg": 29686,
	"./patients/patient2.jpg": 76436,
	"./patients/patient3.jpg": 64593,
	"./patients/patient4.jpg": 79362,
	"./patients/patient5.jpg": 71071,
	"./patients/patient6.jpg": 3696,
	"./patients/patient7.jpg": 48589,
	"./patients/patient8.jpg": 33582,
	"./patients/patient9.jpg": 11627,
	"./payment.png": 13504,
	"./pdf.svg": 39392,
	"./pharmacy-1.png": 56105,
	"./pharmacy-2.png": 7922,
	"./pharmacy-3.png": 29467,
	"./preloader.gif": 88039,
	"./products/product.jpg": 6344,
	"./products/product1.jpg": 55727,
	"./products/product10.jpg": 46815,
	"./products/product11.jpg": 10466,
	"./products/product12.jpg": 58957,
	"./products/product13.jpg": 15504,
	"./products/product14.jpg": 46659,
	"./products/product15.jpg": 65606,
	"./products/product2.jpg": 72736,
	"./products/product3.jpg": 98301,
	"./products/product4.jpg": 57782,
	"./products/product5.jpg": 13043,
	"./products/product6.jpg": 12996,
	"./products/product7.jpg": 7393,
	"./products/product8.jpg": 30042,
	"./products/product9.jpg": 1207,
	"./scan-img.png": 82449,
	"./search-bg.png": 42870,
	"./search-svg.gif": 62818,
	"./search.png": 49432,
	"./serive-bg-icon.png": 38170,
	"./service-six-1.jpg": 22746,
	"./service-six-2.jpg": 10597,
	"./service-six-3.jpg": 82984,
	"./service-six-4.jpg": 64571,
	"./service-sixteen-icon.png": 20320,
	"./service/service-1.jpg": 13581,
	"./service/service-2.jpg": 674,
	"./service/service-3.jpg": 13343,
	"./services-six-1.png": 9789,
	"./shape-01.png": 86121,
	"./shape-02.png": 55154,
	"./shape-03.png": 69979,
	"./shape-04.png": 6116,
	"./shape-05.png": 60013,
	"./shape-06.png": 46038,
	"./shape-07.png": 42975,
	"./shapes/2 561.png": 3923,
	"./shapes/Ellipse 7.png": 24702,
	"./shapes/Ellipse 8.png": 80457,
	"./shapes/alarm.png": 36980,
	"./shapes/blog-img01.jpg": 71096,
	"./shapes/blog-img01.png": 5724,
	"./shapes/blog-img02.jpg": 8551,
	"./shapes/blog-img03.jpg": 52714,
	"./shapes/bro-01.png": 40870,
	"./shapes/bro-02.png": 82109,
	"./shapes/bro-03.png": 44628,
	"./shapes/bro-04.png": 6891,
	"./shapes/bro-05.png": 69410,
	"./shapes/circle-left.png": 15181,
	"./shapes/circle-right.png": 73230,
	"./shapes/clinic-bg.png": 64071,
	"./shapes/consult.png": 44067,
	"./shapes/doc-img-01.jpg": 59247,
	"./shapes/doctor-bg.jpg": 10336,
	"./shapes/doctor-right-bg.jpg": 41435,
	"./shapes/exper.png": 24271,
	"./shapes/graph-01.png": 42099,
	"./shapes/graph-02.png": 96344,
	"./shapes/graph-03.png": 17473,
	"./shapes/graph-04.png": 99758,
	"./shapes/map-plus.png": 36496,
	"./shapes/shape-1.png": 22618,
	"./shapes/shape-2.png": 47281,
	"./shapes/shape-3.png": 7336,
	"./shapes/shape-4.png": 82503,
	"./shapes/spec-01.png": 6796,
	"./shapes/spec-02.png": 9447,
	"./shapes/spec-03.png": 56958,
	"./shapes/spec-04.png": 40049,
	"./shapes/spec-05.png": 29832,
	"./shapes/spec-06.png": 83043,
	"./shapes/spec-07.png": 18938,
	"./shapes/spec.png": 76378,
	"./slide1.jpg": 88928,
	"./slide2.jpg": 71919,
	"./slider-bg.jpg": 1367,
	"./slider/banner-01.jpg": 93944,
	"./slider/banner-02.jpg": 47751,
	"./slider/blue-bg.png": 36014,
	"./slider/book-doc-01.jpg": 49436,
	"./slider/doctor-bg.jpg": 92925,
	"./slider/doctor1-bg.jpg": 77574,
	"./slider/feature-bg.jpg": 30682,
	"./slider/feature-img.jpg": 48894,
	"./slider/patient-bg.jpg": 32713,
	"./slider/patient1-bg.jpg": 25802,
	"./slider/slider-1.jpg": 73189,
	"./slider/slider-2.jpg": 50586,
	"./slider/slider-3.jpg": 14423,
	"./slider/slider-4.jpg": 49580,
	"./slider/slider-5.jpg": 71273,
	"./slider/slider-6.jpg": 44542,
	"./slider/slider-7.jpg": 76027,
	"./special-banner.jpg": 17916,
	"./specialist-bg.jpg": 75631,
	"./specialities/Cardiology.png": 66469,
	"./specialities/Chiropractic.png": 37703,
	"./specialities/Dentist.png": 51167,
	"./specialities/Dermatalogy.png": 50047,
	"./specialities/Gynecology.png": 84366,
	"./specialities/Gynecology.svg": 79658,
	"./specialities/Neurology.png": 85724,
	"./specialities/Ophthalmology.png": 82969,
	"./specialities/Orthopedic.png": 21405,
	"./specialities/Otology.png": 88841,
	"./specialities/Pediatric.png": 53109,
	"./specialities/Psychiatry.png": 69210,
	"./specialities/Pulmonologist.svg": 31728,
	"./specialities/Pulmonology.png": 81359,
	"./specialities/Rhinology.png": 60095,
	"./specialities/allergist.svg": 83929,
	"./specialities/default-speciality1.png": 61490,
	"./specialities/default_speciality3.png": 7074,
	"./specialities/dermatologist.svg": 3522,
	"./specialities/endocrinology.svg": 33652,
	"./specialities/female-doctor.svg": 57132,
	"./specialities/oncology.svg": 26690,
	"./specialities/pediatric.svg": 16095,
	"./specialities/physiotherapist.svg": 93662,
	"./specialities/pt-dashboard-01.png": 85031,
	"./specialities/pt-dashboard-02.png": 66028,
	"./specialities/pt-dashboard-03.png": 18293,
	"./specialities/pt-dashboard-04.png": 78170,
	"./specialities/specialities-01.svg": 76701,
	"./specialities/specialities-02.png": 56692,
	"./specialities/specialities-02.svg": 64606,
	"./specialities/specialities-03.svg": 27183,
	"./specialities/specialities-04.svg": 9712,
	"./specialities/specialities-05.svg": 8161,
	"./specialities/specialities-06.svg": 42770,
	"./stores/store-01.jpg": 11090,
	"./stores/store-02.jpg": 20989,
	"./stores/store-03.jpg": 81760,
	"./stores/store-04.jpg": 52691,
	"./stores/store-05.jpg": 89526,
	"./stores/store-06.jpg": 79105,
	"./stores/store-07.jpg": 1060,
	"./stores/store-08.jpg": 98775,
	"./stores/store-09.jpg": 4314,
	"./stores/store-10.jpg": 54896,
	"./stores/store-11.jpg": 7117,
	"./stores/store-12.jpg": 61186,
	"./stores/store-13.jpg": 52895,
	"./stores/store-14.jpg": 1460,
	"./stores/store-15.jpg": 15793,
	"./stores/store-16.jpg": 88038,
	"./testimonial-2.jpg": 88170,
	"./testimonial.jpg": 90331,
	"./testimonialicon-2.png": 50293,
	"./treatment-1.jpg": 89660,
	"./treatment-2.jpg": 14827,
	"./treatment-3.jpg": 35342,
	"./treatment-4.jpg": 72405,
	"./upload-icon.png": 81109,
	"./video-call.jpg": 86430,
	"./way-img.png": 44429,
	"./work-img.png": 1217,
	"./yourdoconly.jpg": 39417,
	"./yourdoconly.png": 44449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;